export default __webpack_public_path__ + "static/media/cedar.side.texture.3dea605e.webp";